// True for the sign-in page and its sub-routes (e.g. /auth/callback).
export const isAuthPath = (pathname: string) => pathname === "/auth" || pathname.startsWith("/auth/");
